import usePrinter from './usePrinter';

export default {
  usePrinter,
};
